import React from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';
import bgDark from '@/assets/storage/bgDark.webp';
import bgDarkMobile from '@/assets/storage/bgDarkMobile.webp';
import bgLightDesktop from '@/assets/storage/bgLightDesktop.webp';
import bgLightMobile from '@/assets/storage/bgLightMobile.webp';
import { initializeAuth } from '@/core/auth/initializeAuth';
import { registerPreloadErrorReload } from '@/core/infrastructure/preload';
import router from '@/router/router';
import { store } from '@/store/store';
import i18n, { i18nReady } from '../i18next.Config';

registerPreloadErrorReload();

// Initialize authentication state before rendering
initializeAuth();

const rootElement = document.documentElement;
rootElement.dataset.theme = store.getState().theme.themeMode === 'dark' ? 'dark' : 'light';
rootElement.style.setProperty('--ds-background-image-light-desktop', `url("${bgLightDesktop}")`);
rootElement.style.setProperty('--ds-background-image-light-mobile', `url("${bgLightMobile}")`);
rootElement.style.setProperty('--ds-background-image-dark-desktop', `url("${bgDark}")`);
rootElement.style.setProperty('--ds-background-image-dark-mobile', `url("${bgDarkMobile}")`);

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

const renderApp = () =>
  root.render(
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <RouterProvider
          future={{
            v7_startTransition: true,
          }}
          router={router}
        />
      </Provider>
    </I18nextProvider>
  );

i18nReady.then(renderApp, renderApp);
